module.exports = __webpack_public_path__ + "img/from_toeic_content.e5a959a9.svg";